var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:('Supprimer'),expression:"'Supprimer'",modifiers:{"hover":true}}],staticClass:"text-danger cursor-pointer"},[_c('font-awesome-icon',{attrs:{"icon":['far', 'trash-alt']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }